import { Switch, Route } from 'react-router-dom'
import { useAppSelector } from 'hooks/store'
import CaseInformationAndPreferences from 'components/features/dashboard/CaseInformationAndPreferences'
import CaseLevelDashboard from 'components/features/dashboard/CaseLevelDashboard'
import FrequentlyAskedQuestions from 'components/features/dashboard/FrequentlyAskedQuestions'
import LawFirmInformation from 'components/features/dashboard/LawFirmInformation'
import PrivateRoute from 'components/features/common/privateroute/PrivateRoute'
import Documents from '../document/Documents'
import AiDocuments from '../document/AiDocuments'
import DocumentsParentFolder from 'components/features/dashboard/document/DocumentsParentFolder'
import DocumentsChildFolder from 'components/features/dashboard/document/DocumentsChildFolder'
import AiDocumentsChecklistItem from 'components/features/dashboard/document/AiDocumentsChecklistItem'
import AiDocumentsSubmissionSummary from 'components/features/dashboard/document/AiDocumentsSubmissionSummary'
import DocumentDetail from 'components/features/dashboard/document/DocumentDetail'
import AiDocumentDetail from 'components/features/dashboard/document/AiDocumentDetail'
import DocumentEdit from 'components/features/dashboard/document/DocumentEdit'
import Courses from 'components/features/dashboard/course/Courses'
import CourseConfirm from 'components/features/dashboard/course/CourseConfirm'
import CourseVerifyInformation from 'components/features/dashboard/course/CourseVerifyInformation'
import CourseVerifySpouseInformation from 'components/features/dashboard/course/CourseVerifySpouseInformation'
import CourseDisclosureAgreement from 'components/features/dashboard/course/CourseDisclosureAgreement'
import CourseInstructions from 'components/features/dashboard/course/CourseInstructions'
import Billing from 'components/features/dashboard/billing/Billing'
import QuestionnaireOverview from 'components/features/dashboard/questionnaire/QuestionnaireOverview'
import QuestionnaireIntroduction from 'components/features/dashboard/questionnaire/QuestionnaireIntroduction'
import QuestionnaireTermsAndConditions from 'components/features/dashboard/questionnaire/QuestionnaireTermsAndConditions'
import QuestionnaireSectionSummary from 'components/features/dashboard/questionnaire/QuestionnaireSectionSummary'
import QuestionnaireForm from 'components/features/dashboard/questionnaire/QuestionnareForm'

import { Content } from './styles'
import QuestionnaireDone from '../questionnaire/QuestionnaireDone'
import QuestionnaireSectionGroupSummary from '../questionnaire/QuestionnaireSectionGroupSummary'

function CaseLevelContent(): JSX.Element {
  const activeCase = useAppSelector((state) => state.activeCase)

  function getCaseLevelDocumentsComponent(): JSX.Element {
    if (activeCase?.matter?.isAiEnabled) {
      return <AiDocuments />
    }
    return <Documents />
  }

  function getDocumentDetailComponent(): JSX.Element {
    if (activeCase?.matter?.isAiEnabled) {
      return <AiDocumentDetail />
    }
    return <DocumentDetail />
  }

  return (
    <Content id='case-level-content'>
      <Switch>
        <PrivateRoute path='/dashboard/caseinformation' exact>
          <CaseInformationAndPreferences />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/lawfirminformation' exact>
          <LawFirmInformation />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/frequentlyaskedquestions' exact>
          <FrequentlyAskedQuestions />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents/edit' exact>
          <DocumentEdit />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents/detail' exact>
          {getDocumentDetailComponent()}
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents/review-submit-detail' exact>
          <DocumentDetail />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents/category' exact>
          <DocumentsParentFolder />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents/subCategory' exact>
          <DocumentsChildFolder />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents/checklistitem' exact>
          <AiDocumentsChecklistItem />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents/submission-summary' exact>
          <AiDocumentsSubmissionSummary />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/documents' exact>
          {getCaseLevelDocumentsComponent()}
        </PrivateRoute>
        <PrivateRoute path='/dashboard/courses/confirm' exact>
          <CourseConfirm />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/courses/verify' exact>
          <CourseVerifyInformation />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/courses/verify-spouse' exact>
          <CourseVerifySpouseInformation />
        </PrivateRoute>
        <PrivateRoute
          path='/dashboard/courses/course-disclosure-agreement'
          exact
        >
          <CourseDisclosureAgreement />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/courses/course-instructions' exact>
          <CourseInstructions />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/courses' exact>
          <Courses />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/questionnaires/introduction' exact>
          <QuestionnaireIntroduction />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/questionnaires/terms' exact>
          <QuestionnaireTermsAndConditions />
        </PrivateRoute>
        <PrivateRoute
          path='/dashboard/questionnaires/sectionsummary/:sectionId'
          exact
        >
          <QuestionnaireSectionSummary />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/questionnaires/groupsummary' exact>
          <QuestionnaireSectionGroupSummary />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/questionnaires/question' exact>
          <QuestionnaireForm />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/questionnaires/questiongroup' exact>
          <QuestionnaireForm />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/questionnaires' exact>
          <QuestionnaireOverview />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/questionnaires/done' exact>
          <QuestionnaireDone />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/billing' exact>
          <Billing />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/case/:caseId' exact>
          <CaseLevelDashboard />
        </PrivateRoute>
        <PrivateRoute path='/dashboard/case' exact>
          <CaseLevelDashboard />
        </PrivateRoute>
        <Route path='*'>
          <div>Not Found</div>
        </Route>
      </Switch>
    </Content>
  )
}

export default CaseLevelContent
